import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { NoIdDialogComponent } from '../no-id-dialog/no-id-dialog.component';
import { SystemTablesService } from '../services/system-tables.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  areTablesLoading$: Observable<boolean>;

  constructor(private systemTablesService:SystemTablesService
  ) { }
  ngOnInit() {
   this.areTablesLoading$ = this.systemTablesService.areSysTablesLoaded$().map(v=>!v);
  }

  hasLoggedIn = false;
  tz: string;

  login(tz: string) {
    this.hasLoggedIn = true;
    this.tz = tz;
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts